import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'
import apiUrl from '../../../constants';
import axios from 'axios';
import packingApis from '../packingb2b/packingb2b'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import Pagination from './../shared/pagination'
import csvHelper from '../reports/importjsontocsv';
import awaitEach from 'await-each'
import Vue from 'vue';
import Boxtable from './../../common_components/boxTable.vue'
import packingBoxList from './../../common_components/packingBoxList.vue'
import common_helper from '../../../common_helper'
import download from 'downloadjs'

export default {
	name: 'Packing',
	components: {
		Loader,
		Multiselect,
		DatePicker,
		Pagination,
		awaitEach,
		Boxtable,
		packingBoxList
	},

	data: function () {
		return {
			box: [],
			packingboxData:[],
			box1: [],
			quantity: 0,
			totalboxqty:0,
			salesChannel:"",
			boxdatas: [],
			tabIndex: 0,
			orignalpendingqty: 0,
			ispackingbuttonenable: true,
			addotherscourier: false,
			showeye1: true,
			ClientErr: '',
			warehouse: '',
			rejectReason: [],
			rejectOptions: ["Color mismatched","Damaged product","Invalid Details"
		],
			hideediticon: false,
			isrejectQc:false,
			showclosebutton: false,
			showerrorCouriercompany: true,
			resultCompleteBoxPacking: [],
			ismanualPackingEnable: false,
			disableQcbutton: false,
			pageLimit: 10,
			totalRows: 0,
			currentPage: 1,
			listb2bQcdone: [],
			listb2bBoxlist: [],
			isweightsaved: false,
			boxid1: '',
			searchFlag: false,
			AddshipmentDetail: false,
			orderProdList: [],
			formattedDate: '',
			listInventorySyncData: [],
			isLoading: false,
			isLoadingFeild: false,
			css1: true,
			css2: false,
			css3: false,
			showButtonManualPacking: false,
			listWarehouseData: [],
			systemLoginCheck: false,
			showBoxInputs: false,
			showBoxDetails: false,
			showProductQcDetails: false,
			isProductReject: false,
			allowPackingComplete: false,
			rejectReasons: [],
			showInvoiceAndLabels: true,
			options: [],
			token: '',
			showQCAndPackingSection: true,
			showPackingCompleteButton: false,
			salesChannelList: [],
			showSplitBoxData: false,
			sourceBoxData: [],
			destinationBoxData: [],
			destinationBoxId: '',
			showSplitButton: false,
			destinationProductID: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			specialInstructionModel:false,
            specialInstructionList:[],
            specialInstructionCount:0,
			specialInstructionButton:false,
			finalObject: {
				warehouseId: '',
				boxId: '',
				boxWeight: 0,
				length:0,
				width:0,
				height:0,
				valpackingbox:'',
				Quantity:'',
				clientName: '',
				salesChannel: '',
				orderId: '',
				totalSkus: '',
				orderShiByDate: '',
				shipmentId: '',
				productId: '',
				boxStatus: '',
				orderStatus: '',
				clientId: '',
				scanproductData: '',
				rejectReasons: '',
				userEmail: '',
				salesChannelList: [],
				courierName: '',
				OthercourierName: '',
				awbNo: '',
				showInvoiceButton: false,
				showLabelButton: false,
				normalOrder: false,
				isRubicon: false,
				isWmall: false,
				isUnicommerce: false,
				isMultiseller: false,
				isNimbus: false,
				isincreff:false,
				cancelProductDetails: [],
				orderType: '',
				sellerName: '',
				totalOrderQty: '',
				userId: '',
				shippingLabel: '',
				invoiceLabel: '',
				shippingCode: '',
				orderTypeInput: '',
				shipmentStatus: '',
				merchantName: '',
				xbEcomFlag: false,
				xbEcomAwbNo: '',
				xbEcomCourierCompany: '',
				orderSelfshipped: '',
				productQty: '',
				showQtyInput: false,
				qcQtyPending: '',
				weight: 0
			},
			Qccomplete: {
				client: '',
				warehouse: '',
				orderid: '',
				Shipbyfromdate: '',
				Shipbytodate: '',
				ordercreatedfromdate: '',
				ordercreatedtodate: '',
				boxweight: '',
				b2b_qc_done: '',
				remainingqty: '',
				pickingboxpending: true
			},
			addinvoicedetails: {
				invoiceno: '',
				value: '',
				ewaybill: '',
				isInvoiceDetailssaved: false,
			},
			addshipdetails: {
				orderId: '',
				totalboxes: 0,
				orderweight: 0
			},
			totalPage: 0,
			totalboxes: 0,
			editweight: false,
			res_client: '',
			res_warehouse: '',
			shippingCourierCompany: null,
			shippingProviderFinal: null,
			showorderDetails:false,
			ispickingbox:false,
			showpackingbox:false,
			validproduct:false,
			packingclose:true,
			showproductdetail:true,
			modalShowForConfirmType:false,
            papertype:"paper",
            invoiceType:"label",
            packingscreenmodel:false,
            listboxdata:[],
            invoiceErr:"",
			shipErr:"",
			showpackingboxdetails:false,
			disableflag:true,
			totalclosedboxseq:0,
			orderQcdone:false,
			pickboxcount:1,
			modalShowForWarning:false,
			packingflag:false,
			isLoading1:false,
			isBulkQty:true,
			b2bPieceLevelPacking:false,
			allremainingpickqty:0,
			isReadonlyFlag: 1,
			lastShipmentInputTime: Date.now(),
            isScanningForShipment: false,
            scanTimeoutForShipment: null,
			client:'',
			clientid:'',
			isAutoFillBoxFlag:0,
			isGeneratePackingSlip:false,
			packingboxslip:''
		}
	},
	filters: {
		moment: function (date) {
			if (date)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
			else {
				return '';
			}
		},
	},
	computed: {
		isComplete() {
			var isComplete = this.addinvoicedetails.invoiceno && this.addinvoicedetails.value && this.ispackingbuttonenable
			return isComplete;
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
		var plaintext = bytes.toString(CryptoJS.enc.Utf8)
		var userdetail = JSON.parse(plaintext)
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.user_type = userdetail.utype
		this.finalObject.userEmail = userdetail.email
		this.finalObject.userId = userdetail.userid
		this.userid = userdetail.userid
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		document.getElementById('packingboxid').disabled=true;
		this.b2bPieceLevelPacking =userdetail.b2bPieceLevelPacking =="true" ? true :false
		this.isBulkQty = !this.b2bPieceLevelPacking
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.checkEancodeFlag();
		this.checkAutoFillBoxFlag();
		switch (this.user_type) {
			case 'system_user':
				this.systemLoginCheck = true
				// this.getWarehouseList()
				// this.getClientList()
				this.showSelectClient = true
				this.showSelectWarehouse = true
				break

			case 'client_user':
				this.$alert(this.$t('common.unauthorisedError'))
				break

			case 'warehouse_user':
				// this.getClientList()
				this.Qccomplete.warehouse = this.finalObject.warehouseId = userdetail.warehouseid
				this.showBoxInputs = true
				this.showSelectClient = true
				this.showSelectWarehouse = false
				break

			default:
				this.$alert(this.$t('common.unauthorisedError'))
				break
		}
	},

	methods: {
		detectKeyPressEventupdate(event) {
			if(this.isReadonlyFlag == 0)
			{
				let currentTime = Date.now();
			// Ignore Enter (13) and Tab (9)
			if (event.keyCode === 13 || event.keyCode === 9) {
				return;
			}

			// First input detected (reset state)
			if (this.lastShipmentInputTime === null) {
				this.lastShipmentInputTime = currentTime;
				this.isScanningForShipment = true; // Assume scanner initially
			}

			let timeDiff = currentTime - this.lastShipmentInputTime;
			// If input is very fast, assume scanner is active
			if (timeDiff <= 50) {
				this.isScanningForShipment = true;
			} else {
				this.isScanningForShipment = false;
			}
			this.lastShipmentInputTime = currentTime;

			// Set a timeout to detect when the scan is complete
			clearTimeout(this.scanTimeoutForShipment);
			
			this.scanTimeoutForShipment = setTimeout(() => {
				if (this.isScanningForShipment && this.finalObject.productid.length > 5) {
				return this.$refs.checkProductid.focus();
				} else {
				this.finalObject.productid = "";
				document.getElementById('productid').value="";
				return this.$alert('Scan the barcode, manual entry not allowed');
				}
			}, 50); // Adjust timing based on your scanner speed
			}
			else{
				return true
			}


		},
		async checkEancodeFlag(){
            let inputPayload = {
                clientid:localStorage.getItem("selectedClient"),
                warehouseid: Number(window.localStorage.getItem("selectedWarehouse")),
            }
                let response = await packingApis.getEancodeFlag(inputPayload, this.token)
                    if (response.data.errorCode == 0) {            
                        if(this.user_type !== 'system_user'){
                            this.isReadonlyFlag = response.data.data.eancodeFlag;
                        }
                    }
        },
		async checkAutoFillBoxFlag(){
            let inputPayload = {
                clientid:localStorage.getItem("selectedClient"),
                warehouseid: Number(window.localStorage.getItem("selectedWarehouse")),
            }
                let response = await packingApis.getAutoFillBoxFlag(inputPayload, this.token)
                    if (response.data.errorCode == 0) {            
                            this.isAutoFillBoxFlag = response.data.data.autofillboxFlag;
                    }
        },
		resetEmotes() {
			if(!this.b2bPieceLevelPacking)
			{let checkboxqty = document.getElementById("checkbox2").checked

			if (checkboxqty) {
				document.getElementById("checkbox2").checked = false
				this.isBulkQty = true
			}
			else {
				document.getElementById("checkbox2").checked = true
				this.isBulkQty = false
			}
		}
		},

		dateFormatDetail(date) {
			if (!date) return ''
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		
		closeModal() {
			this.modalShow = false
		},
		callParent1() {
			this.showeye1 = true;
		},
		loadRejectReason() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.rejectOptions = []
			this.holdOptions = []
			this.input = ({
				reasonType: 'reject',
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rejectReasonList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.status) {
						for (var i = 0; i < result.data.result.length; i++) {
							this.rejectOptions.push(result.data.result[i].reasonname);
						}
						this.rejectedReasonList = result.data;
					}
				}, error => {
					this.isLoading = false;
					//console.error(error)
				});
		},
		closeboxQc(){
			if(!this.finalObject.valpackingbox){
				this.$alertify.error(this.$t('packingb2b.enterPackingBox')); 
				return false;
			}
			if(this.finalObject.valpackingbox != this.finalObject.packingboxId){
				this.$alertify.error( this.$t('packingb2b.packingBoxMismatch'));
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
					clientid: localStorage.getItem('selectedClient'),
					warehouseid:localStorage.getItem('selectedWarehouse'),
					orderid:this.finalObject.orderId,
					boxid:this.finalObject.pickingboxId,
					packingboxid : this.finalObject.valpackingbox,
					totalboxqty:this.totalboxqty,
					boxseq:Number(this.totalclosedboxseq) + 1
		  });
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'packing/updateboxstatusb2b',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				}).then(res=>{
					if(res.data.data.ErrorCode == 0){
						this.isLoading = false;
						this.Qccomplete.b2b_qc_done = 2;
						this.lbhupdateb2b()
						if (this.Qccomplete.remainingqty > 0) {
							this.getBoxDetails(this.finalObject.warehouseId,this.finalObject.boxId,1)
					    }
						this.$alertify.success(res.data.data.msg)
						if(this.packingboxslip != ''  ){
							this.isGeneratePackingSlip = true;
						}
					}else{
						this.isLoading = false;
						this.$alertify.error(res.data.data.msg)
					}
				
				})
		},

		lbhupdateb2b(){
			// /packing/updateboxstatusb2b
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if(this.finalObject.height < 0){
				this.$alertify.error(this.$t('packingb2b.heightWarning'));
                return false;
			}
			if(this.finalObject.length < 0){
				this.$alertify.error(this.$t('packingb2b.lengthWarning'));
                return false;
			}
			if(this.finalObject.width < 0){
				this.$alertify.error(this.$t('packingb2b.widthWarning'));
				return false;
			}
			if(this.finalObject.boxWeight < 0){
				this.$alertify.error(this.$t('packingb2b.boxWeightWarning'));
				return false;
			}
			this.input = ({
					clientid: localStorage.getItem("selectedClient"),
					warehouseid:localStorage.getItem("selectedWarehouse"),
					boxid:this.finalObject.pickingboxId,
					packingboxid : this.finalObject.packingboxId,
						weight: this.finalObject.boxWeight,
						height : this.finalObject.height,
						length : this.finalObject.length,
						width  : this.finalObject.width

		  });
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'b2bpacking/addBoxWeightb2b',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				}).then(res=>{
					this.isLoading = false;
					this.$alertify.success(res.data.data.msg)

				})
		},
		selectpickingbox(){
			this.ispickingbox = document.getElementById("ispickingbox").checked
			if(this.ispickingbox){
				document.getElementById("packingboxid").disabled = true;
				if(this.finalObject.pickingboxId){
					this.finalObject.packingboxId = this.finalObject.pickingboxId
				}else{
					this.finalObject.packingboxId=''
				}
				document.getElementById("packingboxid").value = this.finalObject.packingboxId;
			}else{
				this.finalObject.packingboxId = '';
				document.getElementById("packingboxid").value = '';
				document.getElementById("packingboxid").disabled = false;
			}
			
		},
		getBoxDatas() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				'clientid': localStorage.getItem("selectedClient"),
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'boxid': this.finalObject.pickingboxId,
				'orderid': this.finalObject.orderId
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'packing/getBoxData',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.box =[]
						this.boxdatas = result.data.data.data.boxData
						this.allremainingpickqty = this.boxdatas.length > 0 ? this.boxdatas[0].totalremainingqty : 0
						this.boxdatas.forEach(element => {
							this.box.push({
								
								productid: element.clientproductid,
								ean: element.eancode,
								productname: element.productname,
								quantity: element.qty
							})
						});
					}
				});
		},
		closeAddshipdetails() {
			document.getElementById('awb').disabled = false
			document.getElementById('couriername').disabled = false
			document.getElementById('invoiceNo').disabled = false
			document.getElementById('invoiceValue').disabled = false
			document.getElementById('ewayBill').disabled = false
			document.getElementById('savebtn').disabled = false								
		},
		// manualPackingEnable() {
		// 	var checkbox = document.getElementById("manualPackingEnable").checked
		// 	if (checkbox) {
		// 		this.ismanualPackingEnable = true
		// 		this.finalObject.salesChannelList = this.salesChannelList
		// 		document.getElementById('awbno').disabled = false
		// 		document.getElementById('couriername').disabled = false
		// 		document.getElementById("manualPackingEnable").disabled = true
		// 		this.showInvoiceAndLabels = false
		// 		this.finalObject.showInvoiceButton = false
		// 		this.finalObject.showLabelButton = false
		// 		this.finalObject.courierName = ''
		// 		this.finalObject.awbNo = ''
		// 		this.$validator.reset()

		// 	}
		// },

		// warehouseSelected() {
		// 	this.finalObject.boxId = ''
		// 	if (this.finalObject.warehouseId) {
		// 		this.showBoxInputs = true
		// 	}
		// },
		// getWarehouseListbyclient() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		'clientid': this.Qccomplete.client,
		// 	});
		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 		'data': this.input,
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
		rejectQc(){
              this.isrejectQc = true;
		},
		resetreject(){
			this.isrejectQc = false;
			this.rejectReason=[]
		},
		scanBox(){
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			if(!this.finalObject.packingboxId){
				this.$alertify.error(this.$t('packingb2b.enterPackingBoxID')); 
					return false
			}
			if (!this.finalObject.pickingboxId) {
				this.$alertify.error(this.$t('packingb2b.enterPickingBoxID'));
				return false
			}
			let ispicking_as_pickingbox = 0;
			if(this.finalObject.pickingboxId == this.finalObject.packingboxId){
				ispicking_as_pickingbox = 1;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			const printBoxPayload = {
				"clientid":localStorage.getItem("selectedClient"),
				"warehouseid":window.localStorage.getItem("selectedWarehouse"),
				"packingboxid":this.finalObject.packingboxId,
				"userid":this.userId,
				"useremail":this.finalObject.userEmail,
				"ispickingbox": ispicking_as_pickingbox,
				"orderid":this.finalObject.orderId,
				"boxid":this.finalObject.pickingboxId
			}
			axios({
				method: "POST",
				url: apiUrl.api_url + "b2bpacking/getpackingBoxDetails",
				data: printBoxPayload,
				headers: {
					'Authorization': 'Bearer ' + myStr
				},
			}).then(result => {
			  if(result.data.data.ErrorCode==0){
				this.getBoxDatas()
				this.showpackingboxdetails=false;
				this.showpackingbox=true;
				this.packingboxData=[]
				this.finalObject.valpackingbox=''
				// document.getElementById('valpackingbox').value='';
				
				this.totalboxqty=0
				result.data.data.data.forEach(element => {
					if(element.productid){
				  this.packingboxData.push({
					
					  productid: element.clientproductid,
					  ean: element.eancode,
					  productname: element.productname,
					  quantity: element.productqty
				  })
				}
				this.totalboxqty+=Number(element.productqty)
			  });
			 if(result.data.data.data[0].length){
				this.finalObject.length= result.data.data.data[0].length
			 }else{
				this.finalObject.length= result.data.data.data[0].default_length
			 }
			 if(result.data.data.data[0].width){
				this.finalObject.width= result.data.data.data[0].width
			 }else{
				this.finalObject.width= result.data.data.data[0].default_width
			 }
			 if(result.data.data.data[0].height){
			 this.finalObject.height=  result.data.data.data[0].height
			 }else{
				this.finalObject.height=  result.data.data.data[0].default_height
			 }
			 this.totalclosedboxseq= result.data.data.data[0].closedboxcount
			 this.orderQcdone = result.data.data.data[0].orderQcdone
			 this.pickboxcount =result.data.data.data[0].pickboxcount
			  if(result.data.data.data[0].boxstatus == 'closed'){
				this.$alertify.error(this.$t('packingb2b.qcAlreadyDone')); 
				// this.showpackingbox=false;
				this.packingclose=false;
				this.showproductdetail=false;
				return false;
			}else{
				this.packingclose=true;
				this.finalObject.valpackingbox = this.finalObject.packingboxId
				this.packingboxslip = this.finalObject.packingboxId
				this.showproductdetail=true;
			}
			document.getElementById('packingboxid').disabled=true;
			document.getElementById('ispickingbox').disabled = true;
			  }else{

				this.$alertify.error(result.data.data.msg);
				return false
			  }
			})
		},
		validateProduct(){
			if(!this.finalObject.productid){
				this.$alertify.error(this.$t('common.productIdError'));
					return false
			}
		},

		printpackingBoxslip(){
			let boxids=[]
			boxids.push(this.finalObject.packingboxId)
			if(!this.finalObject.packingboxId){
				this.$alertify.error($t('packingb2b.b2bPacking.table.columns.b2bOrderId'));
					return false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			const printBoxPayload = {
				clientid:localStorage.getItem("selectedClient"),
				boxids:boxids,
				format: "",
				attribute1:"mrp"
			}
			axios({
				method: "POST",
				url: apiUrl.api_url + "generatePackingSlip",
				data: printBoxPayload,
				headers: {
					'Authorization': 'Bearer ' + myStr
				},
				responseType:"blob"
			}).then(result => {
			  const file = new Blob([result.data], { type: "application/pdf" });
			  //Build a URL from the file
			  const fileURL = URL.createObjectURL(file);
			  //Open the URL on new Window
			   const pdfWindow = window.open();
			   pdfWindow.location.href = fileURL;
			})
		},
		async generatePackingBoxSlip(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let result
			let payload=    {
				
					"clientid":localStorage.getItem("selectedClient"),
					"boxids":this.packingboxslip,
					"pageformat": this.papertype=="paper"?"A4":"",
				
			   }
			   let type=""
					type="Invoice"
					payload=    {
				
						"clientid":localStorage.getItem("selectedClient"),
						"boxids":this.packingboxslip,
						"format": this.papertype=="paper"?"A4":""
					
				   }
					 result=await       axios({
						method: 'POST',
						'url': apiUrl.api_url + 'generatePackingBoxSlip',
						'data': payload,
						headers: {
							'Authorization': 'Bearer ' + myStr,
		
						},
					
						 responseType: 'blob'
					})
				
				
				if(this.isJson(result)){
					this.$alertify.error(this.$t('packingb2b.orderDataErr'));
				}else{
			
				let file = window.URL.createObjectURL(result.data);
				const a = document.createElement("a");
				a.href = file;
				a.download = ""+ type+this.addshipdetails.orderId ;
				document.body.appendChild(a);
				a.click();
			
				window.onfocus = function () {                     
				  document.body.removeChild(a)
				}
			}
			this.isGeneratePackingSlip = false;
				//  this.modalShowForConfirmType=false
				// document.getElementById( 'confirmationmodal' ).style.display = 'none';
		
		},
		async generatePackingBoxSlip1(boxid){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let result
			let payload=    {
				
					"clientid":localStorage.getItem("selectedClient"),
					"boxids":boxid,
					"pageformat": this.papertype=="paper"?"A4":"",
				
			   }
			   let type=""
					type="Invoice"
					payload=    {
				
						"clientid":localStorage.getItem("selectedClient"),
						"boxids":boxid,
						"format": this.papertype=="paper"?"A4":""
					
				   }
					 result=await       axios({
						method: 'POST',
						'url': apiUrl.api_url + 'generatePackingBoxSlip',
						'data': payload,
						headers: {
							'Authorization': 'Bearer ' + myStr,
		
						},
					
						 responseType: 'blob'
					})
				
				
				if(this.isJson(result)){
					this.$alertify.error(this.$t('packingb2b.orderDataErr'));
				}else{
			
				let file = window.URL.createObjectURL(result.data);
				const a = document.createElement("a");
				a.href = file;
				a.download = ""+ type+this.addshipdetails.orderId ;
				document.body.appendChild(a);
				a.click();
			
				window.onfocus = function () {                     
				  document.body.removeChild(a)
				}
			}
				//  this.modalShowForConfirmType=false
				// document.getElementById( 'confirmationmodal' ).style.display = 'none';
		
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = this.totalPage = 0;

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;

		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// async getWarehouseList() {
		// 	try {
		// 		this.isLoading = true
		// 		let result = await packingApis.getWarehouseList(this.token)
		// 		this.listWarehouseData = result.data.data
		// 		this.isLoading = false
		// 	} catch (err) {
		// 		console.log(err)
		// 		this.isLoading = false
		// 	}
		// },

		async getWeight() {
			try {
				this.isLoading = true
				let weightResponse = await packingApis.getWeight(this.token)
				this.isLoading = false
				if (weightResponse.status == 200 && weightResponse.data.weight) {
					this.finalObject.boxWeight = parseFloat(weightResponse.data.weight)
				} else {
					this.$alert(this.$t('boxList.weighingMachineError'))
					this.finalObject.boxWeight = 0
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},
		adddetails() {
			this.Qccomplete.client = localStorage.getItem("selectedClient")
			this.Qccomplete.warehouse = localStorage.getItem("selectedWarehouse")
			this.Qccomplete.orderid = this.finalObject.orderId
			this.getb2bQcdonelisting()

		},
		async clearshipdata() {
			this.addinvoicedetails.value = ''
			this.addinvoicedetails.invoiceno = ''
			this.addinvoicedetails.ewaybill = ''
			this.finalObject.awbNo = ''
			this.finalObject.courierName = ''
			this.addshipdetails.orderweight = 0;
			this.addshipdetails.totalboxes = 0;
			this.addshipdetails.orderId = ''
			this.boxid1 = ''
			this.$validator.reset()
		},
		getSpecialInstructionModal(){
            this.specialInstructionModel=true;
        },
		async getSpecialInstruction(){
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
			this.isLoading=true;
            await axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getSpecialPackingInstruction',
              'data': {
                clientid: window.localStorage.getItem('selectedClient'),
				saleschannel:this.finalObject.salesChannel
                },
              headers: {
                'Authorization': 'Bearer ' + myStr,
              },
               })
               .then((response) => {
                this.specialInstructionList = Array.isArray(response.data.data.data) ? response.data.data.data : [];
                this.specialInstructionCount=this.specialInstructionList.length;
				if(this.specialInstructionCount>0){
                    this.specialInstructionButton=true;
                }else{
                    this.specialInstructionButton=false;
                }
				this.isLoading=false;
               })
               .catch((httpException) => {
                 console.error('exception is:::::::::', httpException)
               }); 
         },
        closeSpecialInstructionModal(){
            this.specialInstructionModel=false;
        },
		async getBoxDetails(warehouse, boxid,valRemaningqty = 0) {

			try {
				if (!window.localStorage.getItem("selectedWarehouse")) {
					this.$alertify.error(this.$t('common.warehouseError'))
					this.isLoading = false;
					return false
				}
				if (warehouse != undefined && boxid != undefined) {
					this.finalObject.warehouseId = warehouse;
					this.finalObject.boxId = boxid;
				}
			   if (!this.finalObject.pickingboxId) {
					this.$alertify.error(this.$t('packingb2b.enterPickingBoxID'));
					return false
				}
				this.cleanForm()
				let inputPayload = {
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.pickingboxId
				}
				let boxId = this.finalObject.boxId
				this.isLoading = true
				let response = await packingApis.getBoxDetails(inputPayload, this.token)
				let data = response.data.data.data
				if (response.data.data.ErrorCode == 0) {
					// if(this.finalObject.packingboxId){
					// }
					await this.checkEancodeFlag()
				   await this.checkAutoFillBoxFlag();
					this.showpackingbox=false;
					this.box=[];
					this.showorderDetails= true;
					this.showPackingCompleteButton = true
					this.finalObject.merchantName = data.merchantName
					this.finalObject.clientName = data.clientName
					this.finalObject.orderId = data.orderId
					this.finalObject.salesChannel = data.salesChannel
					this.finalObject.totalSkus = data.totalSkus
					this.finalObject.totalQty = data.totalQty
					this.finalObject.totalOrderQty = data.totalOrderQty
					this.finalObject.cancelQty = data.cancelQty
					this.finalObject.qtyQcAccept = data.qtyQcAccept
					this.finalObject.qtyQcReject = data.qtyQcReject
					this.finalObject.orderShiByDate = data.orderShiByDate
					this.finalObject.shipmentId = data.shipmentId
					this.finalObject.boxStatus = data.boxStatus
					this.finalObject.orderStatus = data.orderStatus
					this.finalObject.orderSelfshipped = data.orderSelfshipped
					this.finalObject.clientId = data.clientId
					this.Qccomplete.boxweight = data.weight == "" ? 0 : data.weight
					this.Qccomplete.b2b_qc_done = data.b2b_qc_done
					this.Qccomplete.remainingqty = data.remainingqty
					this.Qccomplete.pickingboxpending =data.pickingppending
					this.finalObject.sellerName = data.sellerName
					console.log(this.isAutoFillBoxFlag +' '+ this.Qccomplete.b2b_qc_done +'  '+ this.Qccomplete.remainingqty)
					
				    if (this.isAutoFillBoxFlag == 1 && this.Qccomplete.b2b_qc_done != 2 && this.Qccomplete.remainingqty != 0) {
					  this.finalObject.packingboxId = data.packingboxid;
					} else {
						this.finalObject.packingboxId = '';
					}
					if (Number(this.finalObject.cancelQty) > 0) {
						this.finalObject.cancelProductDetails = data.cancelProductDetails
					}
					this.css2 = true
					this.css1 = false
					this.showBoxDetails = true
					// this.finalObject.salesChannelList = data.salesChannelList
					this.salesChannelList = data.salesChannelList
					this.options = data.rejectQCReasons
					if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
						this.showQCAndPackingSection = false
					} else {
						this.showQCAndPackingSection = true
					}
					if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) {
						this.allowPackingComplete = true
					}
					this.finalObject.normalOrder = data.normalOrder
					this.finalObject.isNimbus = data.isNimbus
					this.finalObject.isRubicon = data.isRubicon
					this.finalObject.isWmall = data.isWmall
					this.finalObject.isUnicommerce = data.isUnicommerce
					this.finalObject.isMultiseller = data.isMultiseller
					this.finalObject.isincreff = data.isIncreff
					this.finalObject.xbEcomFlag = data.xbEcomFlag
					this.finalObject.xbEcomAwbNo = data.xbEcomAwbNo
					this.finalObject.xbEcomCourierCompany = data.xbEcomCourierCompany
					this.finalObject.showLabelButton = data.showLabelButton
					this.finalObject.showInvoiceButton = data.showInvoiceButton
					this.finalObject.shippingCourierCompany = null;
					this.finalObject.shippingProviderFinal = null
					if(this.Qccomplete.b2b_qc_done == 2 && valRemaningqty != 1){
						this.getPackingBoxData()
						this.showpackingboxdetails= true;
						this.$alert(this.$t('packingb2b.qcAlreadyDonePickingBox'));

					}
					if (this.showeye1 == true) {
						this.getBoxDatas()
					}
					if (this.finalObject.xbEcomFlag) {
						this.finalObject.courierName = this.finalObject.xbEcomCourierCompany
						// this.finalObject.salesChannelList = []
						// this.finalObject.salesChannelList.push({
						// 	'courierid': this.finalObject.xbEcomCourierCompany,
						// 	'couriername': this.finalObject.xbEcomCourierCompany
						// })
						this.finalObject.awbNo = this.finalObject.xbEcomAwbNo
						this.showInvoiceAndLabels = false
						if (this.finalObject.isRubicon) {
							this.finalObject.orderTypeInput = 'isRubicon'
							this.finalObject.orderType = 'Rubicon'
						} else if (this.finalObject.isWmall) {
							this.finalObject.orderTypeInput = 'isWmall'
							this.finalObject.orderType = 'Wmall'
						} else if (this.finalObject.isMultiseller) {
							this.finalObject.orderTypeInput = 'isMultiseller'
							this.finalObject.orderType = 'Flipkart'
						} else if (this.finalObject.isUnicommerce) {
							this.finalObject.orderTypeInput = 'isUnicommerce'
							this.finalObject.orderType = 'Unicommerce'
						} else {
							this.finalObject.orderTypeInput = 'isNormal'
							this.finalObject.orderType = 'CSV'
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isRubicon) {
						this.showInvoiceAndLabels = true
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.courierName = data.shippingCompany
						// this.finalObject.salesChannelList = []
						// this.finalObject.salesChannelList.push({
						// 	'courierid': this.finalObject.courierName,
						// 	'couriername': this.finalObject.courierName
						// })
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.orderTypeInput = 'isRubicon'
						this.finalObject.orderType = 'Rubicon'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != 'Amazon') {
							// document.getElementById('awb').disabled = true
						} else {
							this.finalObject.awbNo = ''
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isWmall) {

						this.showInvoiceAndLabels = true
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.courierName = data.shippingCompany
						// this.finalObject.salesChannelList = []
						// this.finalObject.salesChannelList.push({
						// 	'courierid': this.finalObject.courierName,
						// 	'couriername': this.finalObject.courierName
						// })
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.orderTypeInput = 'isWmall'
						this.finalObject.orderType = 'Wmall'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isMultiseller) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						// this.finalObject.salesChannelList = []
						// this.finalObject.salesChannelList.push({
						// 	'courierid': this.finalObject.courierName,
						// 	'couriername': this.finalObject.courierName
						// })
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.orderTypeInput = 'isMultiseller'
						this.finalObject.orderType = 'Flipkart'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isUnicommerce) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.shippingCourierCompany = data.shippingCourierCompany
						this.finalObject.awbNo = data.awbNoPacking
						// this.finalObject.salesChannelList = []
						if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
							// this.finalObject.salesChannelList.push({
							// 	'courierid': this.finalObject.shippingCourierCompany,
							// 	'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
							// });
							this.finalObject.shippingProviderFinal = this.finalObject.courierName;
							this.finalObject.courierName = this.finalObject.shippingCourierCompany;
						} else {
							// this.finalObject.salesChannelList.push({
							// 	'courierid': this.finalObject.courierName,
							// 	'couriername': this.finalObject.courierName
							// })
						}
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.shippingCode = data.shippingCode
						this.finalObject.orderTypeInput = 'isUnicommerce'
						this.finalObject.orderType = 'Unicommerce'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isNimbus) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.awbNo = data.awbNoPacking
						// this.finalObject.salesChannelList = []
						// this.finalObject.salesChannelList.push({
						// 	'courierid': this.finalObject.courierName,
						// 	'couriername': this.finalObject.courierName
						// })
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.orderTypeInput = 'isNimbus'
						this.finalObject.orderType = 'Nimbus'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awb').value = this.finalObject.awbNo
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true
					} else if (this.finalObject.normalOrder) {
						this.finalObject.orderTypeInput = 'isNormal'
						this.showInvoiceAndLabels = false
						this.finalObject.orderType = 'CSV'

					}else if (this.finalObject.isincreff) {
						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCourierCompany
						this.finalObject.shippingCourierCompany = data.shippingCourierCompany
						this.finalObject.awbNo = data.awbNoPacking
						// this.finalObject.salesChannelList = []
						if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
							// this.finalObject.salesChannelList.push({
							// 	'courierid': this.finalObject.shippingCourierCompany,
							// 	'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
							// });
							this.finalObject.shippingProviderFinal = this.finalObject.courierName;
							this.finalObject.courierName = this.finalObject.shippingCourierCompany;
						} else {
							// this.finalObject.salesChannelList.push({
							// 	'courierid': this.finalObject.courierName,
							// 	'couriername': this.finalObject.courierName
							// })
						}
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.shippingCode = data.shippingCode
						this.finalObject.orderTypeInput = 'isIncreff'
						this.finalObject.orderType = 'Increff'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						// Vue.nextTick(() => {
						// document.getElementById('awbno').disabled = true
						// document.getElementById('couriername').disabled = true	
						// })					
					}
					document.getElementById('boxid').disabled = true
				
					document.getElementById('packingboxid').disabled=false;

				} else {
					this.Qccomplete.b2b_qc_done = data.b2b_qc_done
					this.showPackingCompleteButton = false
					this.showQCAndPackingSection = false
					if (data.isBoxValid) {
						this.showInvoiceAndLabels = true
						this.allowPackingComplete = true
						// this.finalObject.salesChannelList.push({
						// 	'courierid': data.shippingCompany,
						// 	'couriername': data.shippingCompany
						// })
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.shipmentStatus = data.shipmentStatus
						this.finalObject.merchantName = data.merchantName
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.clientName = data.clientName
						this.finalObject.orderId = data.orderId
						this.finalObject.salesChannel = data.salesChannel
						this.finalObject.totalQty = data.totalQty
						this.finalObject.cancelQty = data.cancelQty
						if (Number(this.finalObject.cancelQty) > 0) {
							this.finalObject.cancelProductDetails = data.cancelProductDetails
						}
						this.finalObject.totalOrderQty = data.totalOrderQty
						this.finalObject.orderShiByDate = data.orderShiByDate
						this.finalObject.shipmentId = data.shipmentId
						this.finalObject.boxStatus = data.boxStatus
						this.finalObject.orderStatus = data.orderStatus
						this.finalObject.orderSelfshipped = data.orderSelfshipped
						this.finalObject.clientId = data.clientId
						this.css2 = true
						this.css1 = false
						this.showBoxDetails = true
						this.finalObject.sellerName = data.sellerName
						if(this.isAutoFillBoxFlag == 1 && this.Qccomplete.b2b_qc_done != 2){
							this.finalObject.packingboxId = data.packingboxid
						}
						this.finalObject.normalOrder = data.normalOrder
						this.finalObject.isNimbus = data.isNimbus
						this.finalObject.xbEcomFlag = data.xbEcomFlag
						this.finalObject.isRubicon = data.isRubicon
						this.finalObject.isWmall = data.isWmall
						this.finalObject.isUnicommerce = data.isUnicommerce
						this.finalObject.isMultiseller = data.isMultiseller
						this.finalObject.showLabelButton = data.showLabelButton
						this.finalObject.showInvoiceButton = data.showInvoiceButton
						if (this.finalObject.isRubicon) {
							this.finalObject.orderTypeInput = 'isRubicon'
							this.finalObject.orderType = 'Rubicon'
						} else if (this.finalObject.isWmall) {
							this.finalObject.orderTypeInput = 'isWmall'
							this.finalObject.orderType = 'Wmall'
						} else if (this.finalObject.isMultiseller) {
							this.finalObject.orderTypeInput = 'isMultiseller'
							this.finalObject.orderType = 'Flipkart'
						} else if (this.finalObject.isUnicommerce) {
							this.finalObject.orderTypeInput = 'isUnicommerce'
							this.finalObject.orderType = 'Unicommerce'
						} else if (this.finalObject.isNimbus) {
							this.finalObject.shippingLabel = data.labelUrl
							this.finalObject.invoiceLabel = data.invoiceUrl
							this.finalObject.orderTypeInput = 'isNimbus'
							this.finalObject.orderType = 'Nimbus'
						} else if (this.finalObject.normalOrder) {
							this.finalObject.orderTypeInput = 'isNormal'
							this.finalObject.orderType = 'CSV'
						}
						else if (this.finalObject.isincreff) {
							this.finalObject.orderTypeInput = 'isIncreff'
							this.finalObject.orderType = 'Increff'
						}
						document.getElementById('boxid').disabled = true
					} else {
						this.showInvoiceAndLabels = false
						document.getElementById('boxid').value = null
						this.finalObject.boxId = ""
					}
					this.$alert(response.data.data.msg, boxId);
				}
				
				this.isLoading = false
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
			finally{
				if(this.finalObject.salesChannel!==""){
					this.getSpecialInstruction()
				}  
			}
		},

		cleanForm() {
			this.isLoading = false
			this.isLoadingFeild = false
			this.salesChannelList = []
			this.css1 = true
			this.css2 = false
			this.css3 = false
			this.showButtonManualPacking = false
			this.showBoxDetails = false
			this.showProductQcDetails = false
			this.isProductReject = false
			this.allowPackingComplete = false
			this.rejectReasons = []
			this.showInvoiceAndLabels = true
			this.options = []
			this.showPackingCompleteButton = false
			this.showQCAndPackingSection = false
			this.finalObject.boxWeight = 0
			this.finalObject.clientName = ''
			this.finalObject.salesChannel = ''
			this.finalObject.orderId = ''
			this.finalObject.totalSkus = ''
			this.finalObject.orderShiByDate = ''
			this.finalObject.shipmentId = ''
			this.finalObject.productId = ''
			this.finalObject.productQty = ''
			this.finalObject.showQtyInput = false
			this.finalObject.qcQtyPending = ''
			this.finalObject.boxStatus = ''
			this.finalObject.orderStatus = ''
			this.finalObject.clientId = ''
			this.finalObject.scanproductData = ''
			this.finalObject.rejectReasons = ''
			this.finalObject.salesChannelList = []
			this.finalObject.courierName = ''
			this.finalObject.awbNo = ''
			this.finalObject.showInvoiceButton = false
			this.finalObject.showLabelButton = false
			this.finalObject.normalOrder = false
			this.finalObject.isNimbus = false
			this.finalObject.isRubicon = false
			this.finalObject.isWmall = false
			this.finalObject.isUnicommerce = false
			this.finalObject.isMultiseller = false
			this.finalObject.cancelProductDetails = []
			this.finalObject.orderType = ''
			this.finalObject.sellerName = ''
			this.finalObject.totalOrderQty = ''
			this.finalObject.shippingLabel = ''
			this.finalObject.invoiceLabel = ''
			this.finalObject.shippingCode = ''
			this.finalObject.orderTypeInput = ''
			this.finalObject.shipmentStatus = ''
			this.finalObject.merchantName = ''
			this.showSplitBoxData = false
			this.sourceBoxData = []
			this.destinationBoxData = []
			this.destinationBoxId = ''
			this.destinationProductID = ''
			this.showSplitButton = false
			this.finalObject.orderSelfshipped = ''
			this.isAutoFillBoxFlag = 0;
		},
		resetFormlisting() {
			this.Qccomplete.client = ''
			if (this.user_type != "warehouse_user") {
				this.Qccomplete.warehouse = ''
			}
			this.Qccomplete.orderid = ''
			this.Qccomplete.ordercreatedfromdate = ''
			this.Qccomplete.ordercreatedtodate = ''
			this.Qccomplete.Shipbyfromdate = ''
			this.Qccomplete.Shipbytodate = ''
			this.listb2bQcdone = []
			this.totalRows = 0
			this.searchFlag = false
			this.isGeneratePackingSlip = false;
		},

		resetForm() {
			if (this.systemLoginCheck) {
				this.finalObject.warehouseId = ''
				this.$validator.reset()
			}
			if (this.showeye1 == true) {
				// this.getWarehouseList()
			}
			this.finalObject.xbEcomFlag = ''
			this.finalObject.xbEcomAwbNo = ''
			this.finalObject.xbEcomCourierCompany = false
			this.showSplitBoxData = false
			this.sourceBoxData = []
			this.destinationBoxData = []
			this.destinationBoxId = ''
			this.showSplitButton = false
			this.destinationProductID = ''
			this.isLoading = false
			this.isLoadingFeild = false
			this.salesChannelList = []
			this.css1 = true
			this.css2 = false
			this.css3 = false
			this.showButtonManualPacking = false
			this.showBoxDetails = false
			this.showProductQcDetails = false
			this.isProductReject = false
			this.allowPackingComplete = false
			this.rejectReasons = []
			this.showInvoiceAndLabels = true
			this.options = []
			this.showPackingCompleteButton = false
			this.showQCAndPackingSection = false
			this.finalObject.boxId = ''
			this.finalObject.boxWeight = 0
			this.finalObject.clientName = ''
			this.finalObject.salesChannel = ''
			this.finalObject.orderId = ''
			this.finalObject.totalSkus = ''
			this.finalObject.orderShiByDate = ''
			this.finalObject.shipmentId = ''
			this.finalObject.productId = ''
			this.finalObject.productQty = ''
			this.finalObject.showQtyInput = false
			this.finalObject.qcQtyPending = ''
			this.finalObject.boxStatus = ''
			this.finalObject.orderStatus = ''
			this.finalObject.clientId = ''
			this.finalObject.scanproductData = ''
			this.finalObject.rejectReasons = ''
			this.finalObject.salesChannelList = []
			this.finalObject.courierName = ''
			this.finalObject.awbNo = ''
			this.finalObject.showInvoiceButton = false
			this.finalObject.showLabelButton = false
			this.finalObject.normalOrder = false
			this.finalObject.isNimbus = false
			this.finalObject.isRubicon = false
			this.finalObject.isWmall = false
			this.finalObject.isUnicommerce = false
			this.finalObject.isMultiseller = false
			this.finalObject.cancelProductDetails = []
			this.finalObject.orderType = ''
			this.finalObject.sellerName = ''
			this.finalObject.totalOrderQty = ''
			this.finalObject.shippingLabel = ''
			this.finalObject.invoiceLabel = ''
			this.finalObject.shippingCode = ''
			this.finalObject.orderTypeInput = ''
			this.finalObject.shipmentStatus = ''
			this.finalObject.merchantName = ''
			this.finalObject.orderSelfshipped = ''
			this.showorderDetails = false
			this.finalObject.pickingboxId=''
			this.showpackingbox = false;
			this.validproduct = false;
			this.finalObject.productid='';
			this.finalObject.productQty='';
			this.finalObject.packingboxId='';
			this.finalObject.pickingboxId='';
			this.ispickingbox=false;
			this.showpackingboxdetails=false;
			this.isGeneratePackingSlip = false;
		
			document.getElementById('boxid').value='';
            document.getElementById('boxid').disabled=false;
			//document.getElementById('packingboxid').value='';
			document.getElementById('packingboxid').disabled=true;
			document.getElementById('ispickingbox').disabled = false;
			document.getElementById('ispickingbox').checked = false;
			// document.getElementById('Quantity').value='';
			// document.getElementById('productid').value='';
			// document.getElementById('productid').disabled=false;
			document.getElementById('boxid').value = null
			document.getElementById('boxid').disabled = false
			// document.getElementById('productid').disabled = false
			// document.getElementById('awbno').disabled = false
			// document.getElementById('awbno').value = false
			// document.getElementById('couriername').disabled = false
			// document.getElementById('couriername').value = false
			// document.getElementById("manualPackingEnable").disabled = false
			// document.getElementById('destinationBoxId').value = null
			// document.getElementById('destinationBoxId').disabled = false		
			this.$validator.reset()
		},
        async getWeight() {
			try {
				this.isLoading = true
				let weightResponse = await packingApis.getWeight(this.token)
				this.isLoading = false
				if (weightResponse.status == 200 && weightResponse.data.weight) {
					this.finalObject.boxWeight = parseFloat(weightResponse.data.weight)
				} else {
					this.$alert(this.$t('boxList.weighingMachineError'))
					this.finalObject.boxWeight = 0
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},
		async scanProduct() {
			try {
				this.isProductReject = false
				this.showProductQcDetails = false
				this.finalObject.productQty = ''
				this.finalObject.showQtyInput = false
				this.finalObject.qcQtyPending = ''
				if (!this.finalObject.productid) {
					this.$alert(this.$t('common.productIdError'))

				}
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.pickingboxId,
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.finalObject.orderId,
					productid: this.finalObject.productid.trim()
				}
				this.isLoadingFeild = true
				let response = await packingApis.scanProductPacking(inputPayload, this.token)
				let data = response.data.data.data
				let productId = this.finalObject.productId.trim()
				if (response.data.data.ErrorCode == 0) {
					this.validproduct = true;
					this.finalObject.scanproductData = response.data.data.data
					this.showProductQcDetails = true
					document.getElementById('productid').disabled = true
					// if (response.data.data.data.resultConfigBulkPickingPacking.status && Number(response.data.data.data.qcQtyPending) >= Number(response.data.data.data.resultConfigBulkPickingPacking.limit)) {
						this.finalObject.showQtyInput = true
						this.finalObject.qcQtyPending = Number(response.data.data.data.qcQtyPending)
						this.orignalpendingqty = this.finalObject.qcQtyPending
						this.finalObject.productQty =''
						document.getElementById('Quantity').value=''
					// }
				} else {
					this.finalObject.qcQtyPending = ''
					this.finalObject.productId = ''
					this.finalObject.productQty = ''
					this.finalObject.showQtyInput = false
					this.$alert(response.data.data.msg, productId)
					document.getElementById('productid').disabled = false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		productQC(obj) {
			if (obj == "reject") {
				this.isProductReject = true
			} else {
				this.updateQcDetails(obj)
			}
		},
		resetProduct(){
			document.getElementById('Quantity').value='';
			this.finalObject.productid='';
			this.finalObject.productQty='';
			document.getElementById('productid').value='';
			document.getElementById('productid').disabled=false;
			this.validproduct = false;
		},
		resetpackingform(){
			
			this.showpackingbox=false;
			this.validproduct=false;
			Vue.nextTick(() => {
			document.getElementById('packingboxid').disabled=false;
			document.getElementById('packingboxid').value='';
			document.getElementById('ispickingbox').disabled=false;
			document.getElementById("ispickingbox").checked = false;
			// this.finalObject.pickingboxId=''
			this.finalObject.productid='';
			this.finalObject.productQty='';
			this.finalObject.packingboxId='';
			document.getElementById('Quantity').value='';
			document.getElementById('productid').disabled=false;
			document.getElementById('productid').value='';
			})
		},
		async updateQcDetails(obj) {
			try {
				if(!this.isBulkQty)
					this.finalObject.productQty=1
				if (obj == 'reject' && this.finalObject.rejectReasons.length < 1) {
					this.$alert(this.$t('boxList.rejectReasonError'))
					return false
				}

                if(!this.finalObject.productQty){
					this.$alert(this.$t('packingb2b.enterQCQuantity'));
					return false;
				}
				if(this.finalObject.productQty <= 0){
					this.$alert(this.$t('packingb2b.qcQuantityZeroNegative'));
					return false;	
				}
				if (this.finalObject.showQtyInput && Number(this.finalObject.qcQtyPending) != Number(this.finalObject.productQty)) {
					if (Number(this.finalObject.qcQtyPending) < Number(this.finalObject.productQty)) {
					
						this.$alert(this.$t('boxList.pickedQtyGreaterError'))
						return false;
					}
				}
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.pickingboxId,
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.finalObject.orderId,
					productid: this.finalObject.productid.trim(),
					qcstatus: obj,
					rejectreasons: obj == "reject" ? this.finalObject.rejectReasons : [],
					useremail: this.finalObject.userEmail,
					productqty: this.finalObject.productQty ? this.finalObject.productQty : '',
					packingboxid:this.finalObject.packingboxId ? this.finalObject.packingboxId : '',
					btoborder:1
				}
				this.isLoadingFeild = true
				let response = await packingApis.updateQcDetails(inputPayload, this.token)
				let data = response.data.data.data
				if (response.data.data.ErrorCode == 0) {
					this.packingboxData = []
					this.finalObject.rejectReasons = []
					this.rejectReasons = []
					this.finalObject.productId = ''
					this.finalObject.productQty = ''
					this.finalObject.showQtyInput = false
					this.finalObject.qcQtyPending = ''
					this.validproduct=false;
					this.finalObject.scanproductData = {}
					this.finalObject.qtyQcAccept = data.totalQCAcceptQty
					this.finalObject.qtyQcReject = data.totalQCRejectQty
					this.isProductReject = false
					this.showProductQcDetails = false
					if(this.isBulkQty)
						document.getElementById('Quantity').value='';
					this.finalObject.productid=''
					document.getElementById('productid').value='';
					if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
						this.showQCAndPackingSection = false
					} else {
						this.showQCAndPackingSection = true
					}
					if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) {
						this.allowPackingComplete = true
						this.showPackingCompleteButton = true
						
					}
					this.scanBox();
					this.$alertify.success(response.data.data.msg)
					document.getElementById('productid').disabled = false
				} else {
					this.$alert(response.data.data.msg, this.finalObject.productId.trim())
					document.getElementById('productid').disabled = false
					return false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		rejectedReasonsSelected() {
			let isOther = this.rejectReasons.map(el => el.value).includes("Other")
			if (isOther) {
				this.$prompt(this.$t('rejectreason.rejectReasonPlaceHolder')).then(text => {  
					if (text && text != '' && text != null) {
						this.rejectReasons.push({
							value: text.trim(),
							text: text.trim()
						})
						this.$alert(this.$t('boxList.rejectReasonMsg1'), text)
					} else {
						this.$alert(this.$t('boxList.rejectReasonMsg2'), text)
					}
				})
			}
			this.finalObject.rejectReasons = this.rejectReasons.map(el => el.value)
		},

		// completePacking() {
		// 	if (!this.finalObject.awbNo || !this.finalObject.courierName) {
		// 		this.$validator.validateAll()
		// 		return false
		// 	} else {
		// 		if (Number(this.finalObject.cancelQty) > 0) {
		// 			this.$confirm("Please RackIn Cancelled Products").then((confirm) => {
		// 				if (confirm) {
		// 					// this.completeBoxPacking()
		// 				}
		// 			})
		// 		} else {
		// 			// this.completeBoxPacking()
		// 		}
		// 	}
		// },

		async printInvoice() {
			try {
				if (this.finalObject.isRubicon) {
					this.isLoading = true
					let inputPayload = {
						clientid: localStorage.getItem("selectedClient"),
						shipmentid: this.finalObject.shipmentId,
						orderid: this.finalObject.orderId,
						sellername: this.finalObject.sellerName
					}
					let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
					if (result.data.data.ErrorCode == 0) {
						if (result.data.data.data.invoice_document_external_url) {
							this.windowOpen(result.data.data.data.invoice_document_external_url)
						} else {
							this.$alert(result.data.data.msg)
						}
					} else {
						this.$alert(result.data.data.msg)
					}
					this.isLoading = false
				} else if (this.finalObject.isUnicommerce) {
					if (this.showPackingCompleteButton) {
						//this.windowOpen(this.finalObject.invoiceLabel)
						//alert("hi2")
						//window.open("data:application/pdf;base64, " + this.finalObject.invoiceLabel);
						//	let newdata = "data:application/pdf;base64, " + this.finalObject.invoiceLabel;
						var newWindow = window.open();
						newWindow.document.write('<iframe src="data:application/pdf;base64,' + (this.finalObject.invoiceLabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
						newWindow.document.title = "Invoice-" + this.finalObject.orderId;


					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							var newWindow = window.open();
							newWindow.document.write('<iframe src="data:application/pdf;base64,' + (result.data.data.data.data.invoicelabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
							newWindow.document.title = "Invoice-" + this.finalObject.orderId;
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isMultiseller) {
					if (this.showPackingCompleteButton) {
						this.getInvoiceAndLabelFlipkart(1)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							shipmentid: this.finalObject.shipmentId,
							orderid: this.finalObject.orderId
						}
						let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.finalObject.shippingLabel = result.data.data.data.data
							this.finalObject.invoiceLabel = result.data.data.data.data
							this.getInvoiceAndLabelFlipkart(1)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isWmall) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.invoiceLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.invoicelabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isNimbus) {
					this.windowOpen(this.finalObject.invoiceLabel)
				} else if (this.finalObject.normalOrder) {
					this.printInvoiceWMS()
				} else if (this.finalObject.isincreff) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.invoiceLabel)
					} 
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},

		async printLabel() {
			try {
				if (this.finalObject.xbEcomFlag) {
					this.printLabelWMS()
				} else if (this.finalObject.isRubicon) {
					this.isLoading = true
					let inputPayload = {
						clientid: localStorage.getItem("selectedClient"),
						shipmentid: this.finalObject.shipmentId,
						orderid: this.finalObject.orderId,
						sellername: this.finalObject.sellerName
					}
					let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
					if (result.data.data.ErrorCode == 0) {
						if (result.data.data.data.shipping_label_document_external_url) {
							this.windowOpen(result.data.data.data.shipping_label_document_external_url)
						} else {
							this.$alert(result.data.data.msg)
						}
					} else {
						this.$alert(result.data.data.msg)
					}
					this.isLoading = false
				} else if (this.finalObject.isUnicommerce) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							////passed sales channel
							saleschannel: this.finalObject.salesChannel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.shippinglabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isMultiseller) {
					if (this.showPackingCompleteButton) {
						this.getInvoiceAndLabelFlipkart(2)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							shipmentid: this.finalObject.shipmentId,
							orderid: this.finalObject.orderId
						}
						let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
						this.isLoading = false
						if (result.data.data.ErrorCode == 0) {
							this.finalObject.shippingLabel = result.data.data.data.data
							this.finalObject.invoiceLabel = result.data.data.data.data
							this.getInvoiceAndLabelFlipkart(2)
						} else {
							this.$alert(result.data.data.msg)
						}
					}
				} else if (this.finalObject.isWmall) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.shippinglabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isNimbus) {
					this.windowOpen(this.finalObject.shippingLabel)
				} else if (this.finalObject.normalOrder) {
					this.printLabelWMS()
				} else if (this.finalObject.isincreff) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					} 
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},
		PrintPackdata(data) {
			this.selectedRow = data
			this.showeye1 = false;
		},
		async printInvoiceWMS() {
			try {
				this.isLoading = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					awbno: this.finalObject.awbNo,
					shippingcompany: this.finalObject.courierName
				}
				let resultInvoiceWms = await packingApis.getInvoiceWMS(inputPayload, this.token)
				if (resultInvoiceWms.status) {
					let invoiceData = resultInvoiceWms.data.printData.invoiceData.replace("/n", "")
					var myWindow = window.open("", "MsgWindow", "_blank")
					setTimeout(function () {
						myWindow.document.write(invoiceData)
					}, 2000)
					myWindow.document.title = 'TaxInvoice'
					setTimeout(function () {
						myWindow.print()
					}, 4000)
				} else {
					this.$alert(this.$t('boxList.invoiceURLError'))
				}
				this.isLoading = false
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},

		getInvoiceAndLabelFlipkart(obj) { //stream object function
			let filename = this.finalObject.orderId + ".pdf"
			let data = ""
			if (obj == 1) {
				filename = "Invoice" + this.finalObject.orderId + ".pdf"
				data = this.finalObject.invoiceLabel
			} else {
				filename = "Label" + this.finalObject.orderId + ".pdf"
				data = this.finalObject.shippingLabel
			}
			let a = document.createElement("a");
			a.href = "data:application/octet-stream;base64," + data;
			a.download = filename
			a.click();
		},

		printLabelWMS() {
			let routeData = this.$router.resolve({
				name: 'shippinglabel',
				params: {
					"clientid": localStorage.getItem("selectedClient"),
					"warehouseid": localStorage.getItem("selectedWarehouse"),
					"awbno": this.finalObject.awbNo,
					"orderid": this.finalObject.orderId,
					"shippingcompany": this.finalObject.courierName
				},
				query: {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					awbno: this.finalObject.awbNo,
					orderid: this.finalObject.orderId,
					shippingcompany: this.finalObject.courierName,
				},
			})
			this.windowOpen(routeData.href)
		},

		windowOpen(obj) {
			window.open(obj, '_blank')
		},

		courierSelected() {
			if (this.finalObject.courierName && this.finalObject.courierName == 'Others') {
				this.addotherscourier = true
				this.showerrorCouriercompany = false;
				this.finalObject.courierName = ''
			} else {
				this.addotherscourier = false
			}
		},
		saveOtherCourier() {
			if (this.finalObject.OthercourierName && this.finalObject.OthercourierName != '' && this.finalObject.OthercourierName != null && this.finalObject.OthercourierName != undefined) {
				this.finalObject.OthercourierName = this.finalObject.OthercourierName.replace(/^.{1}/g, this.finalObject.OthercourierName[0].toUpperCase())
				// this.finalObject.salesChannelList.push({
				// 	'courierid': this.finalObject.OthercourierName.trim(),
				// 	'couriername': this.finalObject.OthercourierName.trim()
				// })
				this.finalObject.courierName = this.finalObject.OthercourierName.trim()
				this.$alert(this.$t('boxList.courierCompanyMsg1'), this.finalObject.OthercourierName)
				this.addotherscourier = false;
			} else {
				this.$alert(this.$t('boxList.courierCompanyMsg2'), this.finalObject.OthercourierName)
			}
		},
		splitBox() {
			if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) > 1) {
				this.showSplitBoxData = true
				this.destinationBoxId = ''
				this.destinationProductID = ''
				this.showSplitButton = false
				this.getSplitBoxDetails()
				document.getElementById('destinationBoxId').disabled = false
				document.getElementById('destinationBoxId').value = null
			} else {
				this.$alert(this.$t('boxList.boxSplitError'))
				return false
			}
		},

		async getSplitBoxDetails() {
			try {
				this.sourceBoxData = []
				this.destinationBoxData = []
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
				}
				let resultSplitBoxDetails = await packingApis.getSplitBoxDetails(inputPayload, this.token)
				if (resultSplitBoxDetails.data.data.ErrorCode == 0) {
					resultSplitBoxDetails.data.data.data.forEach((el) => {
						if (el.boxid == this.finalObject.boxId) {
							this.sourceBoxData.push(el)
						} else {
							this.destinationBoxData.push(el)
						}
					})
				} else {
					this.$alert(resultSplitBoxDetails.data.data.msg)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async validateBox() {
			try {
				if (this.destinationBoxId < 1) {
					return false
				}
				if (Number(this.destinationBoxId) == Number(this.finalObject.boxId)) {
					this.$alert(this.$t('boxList.boxIDError'), this.destinationBoxId)
					this.destinationBoxId = ''
					document.getElementById('destinationBoxId').value = null
					return false
				}
				this.isLoadingFeild = true
				let boxId = this.destinationBoxId
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					boxid: this.destinationBoxId,
					userid: this.finalObject.userId,
					shipmentid: this.finalObject.shipmentId
				}
				let resultValidateBox = await packingApis.validateBox(inputPayload, this.token)
				if (resultValidateBox.data.data.ErrorCode == 0 && resultValidateBox.data.data.data) {
					this.$alertify.success(resultValidateBox.data.data.msg)
					document.getElementById('destinationBoxId').disabled = true
					this.showSplitButton = true
				} else {
					this.destinationBoxId = ''
					this.showSplitButton = false
					document.getElementById('destinationBoxId').value = null
					this.$alert(resultValidateBox.data.data.msg, boxId)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async saveWeight() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid:localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					weight: this.Qccomplete.boxweight
				}
				let resultSplitBoxPacking = await packingApis.saveWeight(inputPayload, this.token)
				if (resultSplitBoxPacking.data.data.ErrorCode == 0) {
					this.isweightsaved = true
					this.$alertify.success(resultSplitBoxPacking.data.data.msg)
					// this.getBoxDetails()
				} else {
					this.$alert(resultSplitBoxPacking.data.data.msg)
				}

				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		async saveOrderWeight() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.addshipdetails.orderId,
					weight: this.addshipdetails.orderweight
				}
				let resultSaveOrderweight = await packingApis.saveOrderWeight(inputPayload, this.token)
				if (resultSaveOrderweight.data.data.ErrorCode == 0) {
					this.editweight = false
					// this.$alertify.success(resultSaveOrderweight.data.data.msg)
				} else {
					this.editweight = false
					this.$alert(resultSaveOrderweight.data.data.msg)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		async saveinvoicedetails() {
			try {
				this.isLoadingFeild = true

				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.addshipdetails.orderId,
					invoicenumber: this.addinvoicedetails.invoiceno,
					ewaybill: this.addinvoicedetails.ewaybill != null ? this.addinvoicedetails.ewaybill : "",
					invoicevalue: this.addinvoicedetails.value
				}
				let resultSaveOrderweight = await packingApis.addinvoicedetails(inputPayload, this.token)
				if (resultSaveOrderweight.data.data.ErrorCode == 0) {
					// this.$alertify.success(resultSaveOrderweight.data.data.msg)
					this.addinvoicedetails.isInvoiceDetailssaved = true
				} else {
					this.$alert(resultSaveOrderweight.data.data.msg)
					this.addinvoicedetails.isInvoiceDetailssaved = false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},


		async splitBoxProducts() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					newboxid: this.destinationBoxId,
					userid: this.finalObject.userId,
					shipmentid: this.finalObject.shipmentId,
					boxid: this.finalObject.boxId,
					productid: this.destinationProductID,
					useremail: this.finalObject.userEmail,
				}
				let resultSplitBoxPacking = await packingApis.splitBoxPacking(inputPayload, this.token)
				if (resultSplitBoxPacking.data.data[0].ErrorCode == 0) {
					this.$alertify.success(resultSplitBoxPacking.data.data[0].msg)
					this.getBoxDetails()
				} else {
					this.$alert(resultSplitBoxPacking.data.data[0].msg, this.destinationProductID)
					this.destinationProductID = ''
					document.getElementById('destinationProductID').value = null
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async getb2bQcdonelisting(csvCheck = 0) {
			if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.searchFlag = true

			let inputPayload = {
				limit: this.pageLimit,
				offset: (this.currentPage - 1) * 1,
				pono: this.Qccomplete.orderid,
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromDateFlt: this.dateFormatDetail(this.Qccomplete.ordercreatedfromdate),
				toDateFlt: this.dateFormatDetail(this.Qccomplete.ordercreatedtodate),
				fromDateFltStatus: this.dateFormatDetail(this.Qccomplete.Shipbyfromdate),
				toDateFltStatus: this.dateFormatDetail(this.Qccomplete.Shipbytodate),

			};

			let resultb2b = await packingApis.b2bQclisting(inputPayload, this.token)
			if (resultb2b.data.data.ErrorCode == -1) {
				this.listb2bQcdone = [];
				this.totalRows = 0
				this.isLoading = false;

			} else {
				this.listb2bQcdone = resultb2b.data.data
				this.totalRows = resultb2b.data.count
				this.res_client = resultb2b.data.clientid
				this.res_warehouse = resultb2b.data.warehouseid

				if (this.totalRows > 0) {
					if (this.totalRows <= this.pageLimit) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
					}
				}
				this.isLoading = false;
			}
		},
		markorderpacked() {
			if (!this.finalObject.awbNo || !this.finalObject.courierName) {

                if (!this.finalObject.courierName ) {
                    this.shipErr= this.$t('packingb2b.b2bPacking.modal.courierCompanyError');
                    return false;
                }
                if (!this.finalObject.awbNo ) {
                
                    this.shipErr= this.$t('packingb2b.b2bPacking.modal.awbNoError');
                    return false;
                }           
            
            } else {
            
                if (this.addinvoicedetails.invoiceno == "" || this.addinvoicedetails.invoiceno == null) {
                    this.invoiceErr= this.$t('boxList.invoiceNoError');
                    return false
                }
                if (this.addinvoicedetails.value == "" || this.addinvoicedetails.value == null) {
                    this.invoiceErr= this.$t('boxList.invoiceValueError');
                    return false
                }
				const that = this
				this.isLoading = true
				this.ispackingbuttonenable = false
				awaitEach(this.listb2bBoxlist, async function (item) {
					await that.completeBoxPacking(item)
				}).then(async (result) => {
					await this.saveinvoicedetails()
					// await this.saveOrderWeight()
					this.packingflag=true
					this.isLoading = false
					this.$alertify.success(this.resultCompleteBoxPacking.data.data.msg)
					
				
					this.finalObject.showInvoiceButton = true
					this.finalObject.showLabelButton = true
					this.hideediticon = true
					this.editweight = false
					this.showclosebutton = true
					this.isLoading = false
				})
			}
		},
		completeBoxPacking(item) {
			return new Promise(async (resolve, reject) => {
				try {
					let inputPayload = {
						clientid: localStorage.getItem("selectedClient"),
						warehouseid: Number(window.localStorage.getItem("selectedWarehouse")),
						orderid: this.finalObject.orderId,
						awbno: this.finalObject.awbNo,
						shippingcompany: this.finalObject.courierName,
						boxid: item.boxid,
						useremail: this.finalObject.userEmail,
						userid: this.finalObject.userId,
						boxweight: item.weight,
						shippinglabel: this.finalObject.shippingLabel,
						invoicelabel: this.finalObject.shippingLabel,
						shippingcode: this.finalObject.shippingCode,
						ordertype: this.finalObject.orderTypeInput,
						saleschannel: this.finalObject.salesChannel,
						xbecomflag: this.finalObject.xbEcomFlag,
						shippingprovider: this.finalObject.shippingProviderFinal ? this.finalObject.shippingProviderFinal : '',

					}
					this.resultCompleteBoxPacking = await packingApis.completeBoxPacking(inputPayload, this.token)
					if (this.resultCompleteBoxPacking.data.data.ErrorCode == 0) {
						this.finalObject.boxStatus = 'in_shipping'
						this.finalObject.orderStatus = 'packed'
						this.showPackingCompleteButton = false
						this.showQCAndPackingSection = false
						this.showInvoiceAndLabels = true
						document.getElementById('awb').disabled = true
						document.getElementById('couriername').disabled = true
						document.getElementById('invoiceNo').disabled = true
						document.getElementById('invoiceValue').disabled = true
						document.getElementById('ewayBill').disabled = true
						document.getElementById('savebtn').disabled = true
						let buttons= document.getElementsByClassName('shipinvoice').disabled = false
						for(var i=0; i< buttons.length; i++){
							buttons[i].disabled = false;
						}
						this.disableflag=false
						this.showInvoiceAndLabels = true

						resolve({
							"status": true,
						})
					} else {
						this.$alert(this.resultCompleteBoxPacking.data.data.msg, this.finalObject.boxId)
						resolve({
							"status": false,
						})
					}
				} catch (err) {
					console.log(err)
				}
			})
		},

		async changeBoxStatus() {
			try {
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					orderid: this.finalObject.orderId
				}
				let resultChangestatus = await packingApis.changeBoxStatus(inputPayload, this.token)

				if (resultChangestatus.data.msg == 1) {
					if (this.Qccomplete.remainingqty > 0) {
						this.Qccomplete.remainingqty = this.Qccomplete.remainingqty - 1;
					}
					this.Qccomplete.b2b_qc_done = 2;
					this.isGeneratePackingSlip = true;
					this.$alertify.success(this.$t('packingb2b.boxQCSuccessful'));
				} else {
					this.$alertify.error(this.$t('packingb2b.boxQCFail'));
					if (this.Qccomplete.remainingqty > 0) {
						this.resetForm()
					}
				}
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		async getBoxDetailsb2b(csvCheck) {
			return new Promise(async (resolve, reject) => {
				if (localStorage.getItem("selectedClient") == 'undefined') {
					this.WarehouseErr = this.$t('common.clientError');
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				  }
				  if (localStorage.getItem("selectedWarehouse") == 'undefined') {
					this.WarehouseErr = this.$t('common.warehouseError');
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				  }
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				var dataFilter = {};
				this.searchFlag = true
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.addshipdetails.orderId
				};
				Object.entries(inputPayload).forEach(([k, v]) => {
					let skipkeys = [];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						dataFilter[k] = v;
					}
				})
				let resultb2b = await packingApis.b2bpackedboxlisting(inputPayload, this.token)
				this.listb2bBoxlist = resultb2b.data.data.data
				if (this.listb2bBoxlist.length > 0) {
					if (csvCheck == 1) {
						this.csvFields = {
							'b2b_qc_done': 'b2b_qc_done',
							'order_id': 'order_id',
							'totalboxquantity': 'TotalQuantity',
							'boxid': 'Box ID',
							'weight': 'weight',
							'length': 'Length',
							'width': 'Width',
							'height': 'Height'
						}

						var dateFilter = [];
						var skipFilter = ['b2b_qc_done', 'order_id'];
						csvHelper.data.jsonToCSV('Boxlisting', this.listb2bBoxlist, this.csvFields, dateFilter, skipFilter, dataFilter);
					} else {
						var orderweight = 0;
						this.listb2bBoxlist.filter(function (el) {
							orderweight = orderweight + parseInt(el.weight);
						});

						this.boxid1 = resultb2b.data.data.data[0].boxid
						resolve({
							"boxid": this.boxid1,
							"orderweight": orderweight
						})
					}
				} else {
					resolve({
						"boxid": "",
						"orderweight": 0
					})
				}
			})
		},
		///////////////shiping details functions

		AcceptQc(){},
            resetErr(){
                this.invoiceErr="";
                this.shipErr="";
            },

        async getPackingBoxData(){
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            try{
            let userToken = window.localStorage.getItem('userToken')
            let myStr = userToken.replace(/"/g, '');
			this.input = ({
                'clientid': localStorage.getItem("selectedClient"),
                'boxtype': "",
                'warehouseid': localStorage.getItem("selectedWarehouse"),
                'offset': 0,
                'limit':100,
                'boxcon': "",
                'csvData': 0,
                'order_id':  this.addshipdetails.orderId || this.finalObject.orderId ,
                'boxid':"",
                'pickingboxid': this.finalObject.pickingboxId
                
            });
            
        let packingBoxes=await  axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getb2bpackingboxlist',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            if(packingBoxes &&packingBoxes.data.data.length>0)
{
            
        
            // this.listboxdata= packingBoxes.data.data.map(e =>({ ...e ,lbh:e.length.concat("l*",e.width,"b*",e.height,"h")}))
    

            for(const e of packingBoxes.data.data) {
            
                e.lbh=e.length.concat("l*",e.width,"b*",e.height,"h")
		   }
		   this.listboxdata=[];
		 this.listboxdata = packingBoxes.data.data;
        }
        }catch(err){
           }
        
        },

        modalShowForConfirm(){
        this.modalShowForConfirmType=false;
        document.getElementById( 'confirmationmodal' ).style.display = 'none';
        Vue.nextTick(() => {document.getElementById( 'packingscreenmodel' ).style.display = 'block';})
        
        
        
        
		},
		
        modalcloseForwarning(){
			this.modalShowForWarning=false;
			document.getElementById( 'warningmodal' ).style.display = 'none';
			Vue.nextTick(() => {document.getElementById( 'packingscreenmodel' ).style.display = 'block';})
			
			
			
			
			},
    

		getCourierCompList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
	  
			this.input = ({})
			axios({
			  method: "Post",
			  url: apiUrl.api_url + "getCourierList",
			  data: this.input,
			  headers: {
				'Authorization': 'Bearer ' + myStr
			  }
			})
			  .then(result => {
				if (result.data.ErrorCode == 0) {
				  this.finalObject.salesChannelList =result.data.data.rows;
				
				} else {
				  this.$alertify.error(this.$t('packingb2b.noCourierCompanyDetailsFound'));
				}
			  }, error => {
				console.error(error)
			  })
		  },
		  resetShipDetailsform(){
			document.getElementById("invoiceNo").value=""
			document.getElementById("invoiceValue").value=""
			document.getElementById("ewayBill").value=""
			document.getElementById("awb").value=""
			document.getElementById("couriername").value=""
						this.listboxdata=[];
		  },
        async AddshipmentDetails(data, client, warehouse) {
			this.closeAddshipdetails()
			this.packingflag=false
		    this.resetShipDetailsform();
			let buttons= document.getElementsByClassName('shipinvoice')
			for(var i=0; i< buttons.length; i++){
				buttons[i].disabled = true;						
			}
			this.isLoading1=true
			this.disableflag=true
			this.modalShowForConfirmType=false;
			this.packingscreenmodel=true;
			this.client=client;
			this.quantity=data.acceptedqty;
			this.addshipdetails.orderId = data.order_id;
			this.salesChannel=data.saleschannel;
		
			await this.getBoxDetailsb2b()
			
			this.finalObject.pickingboxId=this.boxid1;
			this.finalObject.warehouseId=warehouse;
		
			this.getBoxDetails(warehouse, this.boxid1,1)
			this.isLoading=false
			this.finalObject.clientId=client;
			this.finalObject.orderId= data.order_id;
			this.finalObject.salesChannel=data.saleschannel;
			const pickingboxid=this.finalObject.pickingboxId
			this.finalObject.pickingboxId=""
			this.getPackingBoxData()
			this.finalObject.pickingboxId=pickingboxid

			this.getCourierCompList();
			this.isLoading1=false

		},
		closeconfirmmodel(){
			this.modalShowForWarning=false
			this.packingscreenmodel=false
			
			document.getElementById( 'warningmodal' ).style.display = 'none';
			this.getb2bQcdonelisting()
		},
		showWarning(){
			if(this.packingflag){
				this.modalShowForWarning=true;
				document.getElementById( 'warningmodal' ).style.display = 'block';
				// this.packingflag=false
			}
			else 
			this.packingscreenmodel=false
		},

        selectType(type){
			this.modalShowForConfirmType=true;
        document.getElementById( 'confirmationmodal' ).style.display = 'block';
            
        if(type)
            this.invoiceType="label"
            else
            this.invoiceType="slip"
        },
        async   downloadShipLabel(){
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        let result
        let payload=    {
            
                "clientid":localStorage.getItem("selectedClient"),
                "boxids":this.listboxdata.map(e=>(e.boxid)),
                "pageformat": this.papertype=="paper"?"A4":"",
                "barcodeformat": ""
            
		   }
		   let type=""
        
            if(this.invoiceType=="label"){
				type="ShipLabel"
            result=await        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'generateShipLabel',
                'data': payload,
                headers: {
                    'Authorization': 'Bearer ' + myStr,

                },
            
                 responseType: 'blob'
            })
            }
            else{
				type="Invoice"
                payload=    {
            
                    "clientid":localStorage.getItem("selectedClient"),
                    "boxids":this.listboxdata.map(e=>(e.boxid)),
                    "format": this.papertype=="paper"?"A4":""
                
               }
                 result=await       axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'generatePackingSlip',
                    'data': payload,
                    headers: {
                        'Authorization': 'Bearer ' + myStr,
    
                    },
                
                     responseType: 'blob'
                })
			}
			
			if(this.isJson(result)){
				this.$alertify.error(this.$t('packingb2b.orderDataErr'));
			}else{
        
            let file = window.URL.createObjectURL(result.data);
            const a = document.createElement("a");
            a.href = file;
            a.download = ""+ type+this.addshipdetails.orderId ;
            document.body.appendChild(a);
            a.click();
        
            window.onfocus = function () {                     
              document.body.removeChild(a)
			}
		}
            //  this.modalShowForConfirmType=false
            // document.getElementById( 'confirmationmodal' ).style.display = 'none';
		},
		 isJson(str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},


        onPageChange(page) {
            this.currentPage = page;
            this.getb2bQcdonelisting()
        },


	}

}



// WEBPACK FOOTER //
// ./src/views/components/packingb2bnew/packingb2bnew.component.js